export default class HasRoleRequest {
  roleCode: string;
  token?: string;
  tenantId?: number;
  siteId?: number;
  includeInherited?: boolean;
  constructor(roleCode: string, token?: string, tenantId?: number, siteId?: number, includeInherited?: boolean) {
    this.roleCode = roleCode;
    this.token = token;
    this.tenantId = tenantId;
    this.siteId = siteId;
    this.includeInherited = includeInherited;
  }
}
